export * from './lib/pdf-viewer.component';
